import { DiscussionSummary } from "@cnx/common";
import { Text } from "@mantine/core";
import { IconCheck, IconChecks } from "@tabler/icons-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface LastMessagePreviewProps {
  discussion: DiscussionSummary;
  currentUserId: string | null | undefined;
  typingMessage?: string;
  showSender?: boolean;
}

export const LastMessagePreview: FC<LastMessagePreviewProps> = ({
  discussion,
  currentUserId,
  typingMessage,
  showSender = false,
}) => {
  const { t } = useTranslation("discussions");

  if (discussion.id && typingMessage) {
    return (
      <Text fz="xs" c="var(--color-blue)" className="truncate">
        {typingMessage}
      </Text>
    );
  }

  const isCurrentUser = discussion.lastMessageCreatedBy === currentUserId;
  const senderName = isCurrentUser ? "" : discussion.lastMessageSenderName;

  return (
    <Text fz="xs" c="var(--color-gray-dark)" className="truncate">
      {isCurrentUser &&
        (discussion.isRead === 0 ? (
          <IconCheck size={16} color="black" className="inline-block mr-1" />
        ) : (
          <IconChecks size={16} color="#10A0ED" className="inline-block mr-1" />
        ))}
      {showSender && senderName && (
        <Text component="span" fw={600} fz={"xs"}>
          {senderName}:{" "}
        </Text>
      )}
      {discussion.lastMessage || t("attachment").toLowerCase()}
    </Text>
  );
};
